import React from "react";

import { Field, ErrorMessage } from "formik";
import {
  FaUser,
  FaCalendarAlt,
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhone,
  FaCar,
  FaAllergies,
  FaWheelchair,
} from "react-icons/fa";

import { FaNoteSticky } from "react-icons/fa6";
import FormField from "../components/FormField";
import InfoTooltip from "../components/InfoTooltip";
import RadioButton from "../components/RadioButton";
export const Step1 = ({ colors }) => (
  <div
    className="space-y-6 p-6 rounded-lg "
    style={{ backgroundColor: colors.background }}
  >
    <h3
      className="text-2xl font-semibold border-b pb-2"
      style={{ borderColor: colors.border }}
    >
      Informations personnelles
    </h3>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <FormField name="nom" label="Nom" icon={FaUser} required />
      <FormField name="prenom" label="Prénom" icon={FaUser} required />
    </div>

    <FormField name="pseudo" label="Pseudo ImagiGeeks" icon={FaUser} required />
    <FormField
      name="dateNaissance"
      label="Date de naissance"
      icon={FaCalendarAlt}
      type="date"
      required
    />
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      <FormField
        name="adressePostale"
        label="Adresse postale"
        icon={FaMapMarkerAlt}
        rows={3}
        required
      />
      <FormField
        name="zipCode"
        label="Code Postale"
        icon={FaMapMarkerAlt}
        rows={3}
        required
      />
      <FormField
        name="city"
        label="Ville"
        icon={FaMapMarkerAlt}
        rows={3}
        required
      />
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <FormField
        name="email"
        label="Adresse Mail"
        icon={FaEnvelope}
        type="email"
        required
      />
      <FormField
        name="telephone"
        label="Téléphone"
        icon={FaPhone}
        type="tel"
        required
      />
    </div>

    <div>
      <span
        className="block text-sm font-medium mb-2"
        style={{ color: colors.text }}
      >
        <FaCar
          className="inline-block mr-2"
          style={{ color: colors.primary }}
        />
        Es-tu véhiculé.e ? <span style={{ color: colors.secondary }}>*</span>
      </span>
      <div className="space-y-2">
        {["Oui", "Non"].map((option, index) => (
          <RadioButton
            name="vehicule"
            value={option}
            label={option}
            key={index}
          />
        ))}
      </div>
      <ErrorMessage
        name="vehicule"
        component="div"
        className="mt-1 text-sm"
        style={{ color: colors.secondary }}
      />
    </div>

    <FormField
      name="allergies"
      label="Allergies"
      icon={FaAllergies}
      as="textarea"
      rows={2}
      hasInfo={true}
      infoTitle="Informations Importantes"
      info="Cette information est recueillie pour faciliter l'organisation des repas lors d'événements, qu'ils soient fournis par la convention ou partagés avec l'association. Elle peut également être utilisée en cas d'urgence médicale pour permettre une prise en charge rapide par les secours."
    />

    <FormField
      name="notes"
      label="Notes personnel"
      icon={FaNoteSticky}
      as="textarea"
      rows={4}
      hasInfo={true}
      infoTitle="Notes Importantes"
      info="Les notes personnelles sont des informations supplémentaires que vous souhaitez nous communiquer. Elles peuvent inclure des détails importants ou spécifiques que vous jugez utiles de partager."
    />
    <section className="flex items-center space-x-2 justify-between">
      <div className="w-full flex">
        <Field
          name="pmr"
          type="checkbox"
          className="rounded"
          style={{
            accentColor: colors.primary,
            borderColor: colors.border,
          }}
        />
        <span style={{ color: colors.text }}>
          <FaWheelchair
            className="inline-block mr-2 ml-3"
            style={{ color: colors.primary }}
          />
          Mention PMR
        </span>
      </div>
      <InfoTooltip
        title="PMR"
        text="La mention PMR est recueillie afin d'anticiper et d'organiser, si nécessaire, des solutions d'accès adaptées pour les personnes à mobilité réduite, notamment lors de l'hébergement ou d'autres situations spécifiques."
      />
    </section>
  </div>
);
